import React from "react";
import {
  Grid,
  Card,
  Box,
  Typography,
  Chip,
  Button
} from "@mui/material";

const getStatusColor = (status) => {
  switch (status?.toLowerCase()) {
    case "closed":
      return "#4caf50";
    case "open":
      return "#ffc107";
    case "regression":
      return "#f44336";
    default:
      return "#9e9e9e";
  }
};

const ViolationsList = ({ violations, violationTypes, navigate }) => {
  if (!violations || violations.length === 0) {
    return <Typography>No violations found for this member.</Typography>;
  }

  return (
    <Grid container spacing={2}>
      {violations.map((violation) => (
        <Grid item xs={12} key={violation.id}>
          <Card
            sx={{
              borderRadius: 2,
              boxShadow: 2,
              borderLeft: `6px solid ${getStatusColor(violation.status)}`,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: 2,
            }}
          >
            {/* Left Content */}
            <Box>
              <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                VLT-{violation.id}
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ marginBottom: 1 }}
              >
                {violationTypes.find((type) => type.id === violation.ccr_violation_type_id)?.title || "Type Not Found"}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {new Date(violation.violated_at).toLocaleDateString()}
              </Typography>
            </Box>

            {/* Right Content */}
            <Box display="flex" alignItems="center" gap={2}>
              <Chip
                label={violation.status.toUpperCase()}
                sx={{
                  backgroundColor: getStatusColor(violation.status),
                  color: "#fff",
                  fontWeight: "bold",
                  paddingX: 1.5,
                }}
              />
              <Button
                variant="outlined"
                size="small"
                onClick={() => navigate(`/home/violations/${violation.id}`)}
                sx={{ fontWeight: "bold", height: "fit-content" }}
              >
                View Details
              </Button>
            </Box>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default ViolationsList;
